export default __webpack_public_path__ + "static/media/dog_head.d862cbd4.svg";